import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateQuestionGraphTypeRPC } from "./updateQuestionGraphTypeRPC";

export class UpdateQuestionGraphTypeRPCClientImpl extends UpdateQuestionGraphTypeRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateQuestionGraphTypeRPC.Request): Promise<LeoRPCResult<UpdateQuestionGraphTypeRPC.Response, UpdateQuestionGraphTypeRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-dashboard/UpdateQuestionGraphType",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateQuestionGraphTypeRPC.ResponseDTO,
      UpdateQuestionGraphTypeRPC.Errors.ErrorsDTO,
      UpdateQuestionGraphTypeRPC.Response,
      UpdateQuestionGraphTypeRPC.Errors.Errors
    >(
      response,
      "survey-dashboard/UpdateQuestionGraphType",
      UpdateQuestionGraphTypeRPC.Response.fromDTO,
      UpdateQuestionGraphTypeRPC.Errors.fromDTO
    );
  }
}
